export default __webpack_public_path__ + "static/media/330_dummy2016-ferienwohnung01-de.f701eae2.png";